import { onMounted, onUnmounted, ref } from 'vue'

export function useMediaQuery(query) {
  const mediaQuery = typeof window !== 'undefined' ? window.matchMedia(query) : null
  const matches = ref(mediaQuery?.matches ?? false)

  function update() {
    matches.value = mediaQuery?.matches ?? false
  }

  onMounted(() => {
    if (!mediaQuery) return

    update()
    mediaQuery.addEventListener('change', update)
  })

  onUnmounted(() => {
    mediaQuery?.removeEventListener('change', update)
  })

  return matches
}
